import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/setting.svg',
})
export class SettingComponent {}
